import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import DynamicPage from "@/pages/DynamicPage";
import ServiceDetail from "@/pages/ServiceDetail";
import ServicesIndex from "@/pages/ServicesIndex";
import AreaLanding from "@/pages/AreaLanding";
import Careers from "@/pages/Careers";
import ContactUs from "@/pages/ContactUs";
import PrivacyNotice from "@/pages/PrivacyNotice";
import CookiePolicy from "@/pages/CookiePolicy";
import AccessibilityStatement from "@/pages/AccessibilityStatement";
import RegisteredOffices from "@/pages/RegisteredOffices";
import ProcessPage from "@/pages/ProcessPage";
import ExpertisePage from "@/pages/ExpertisePage";
import FacilityManagementPage from "@/pages/FacilityManagementPage";
import QuotePage from "@/pages/QuotePage";
import ScrollHint from "@/components/site/ScrollHint";
import CookieConsent from "@/components/site/CookieConsent";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminPages from "@/pages/admin/AdminPages";
import PageEditor from "@/pages/admin/PageEditor";
import AdminServices from "@/pages/admin/AdminServices";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminSiteImages from "@/pages/admin/AdminSiteImages";
import AdminIntegrations from "@/pages/admin/AdminIntegrations";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminBlog from "@/pages/admin/AdminBlog";
import BlogEditor from "@/pages/admin/BlogEditor";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminHiring from "@/pages/admin/AdminHiring";
import AdminCollection from "@/pages/admin/AdminCollection";
import AdminActivity from "@/pages/admin/AdminActivity";
import AdminPipeline from "@/pages/admin/AdminPipeline";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import { Toaster } from "@/components/ui/sonner";

function PublicChrome() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <>
      <ScrollHint />
      <CookieConsent />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Homepage — CMS-driven by default */}
          <Route path="/" element={<DynamicPage homepage />} />

          {/* Legacy static fallback (kept for safety; not linked) */}
          <Route path="/legacy" element={<Landing />} />

          {/* Existing dedicated pages (logic-heavy) */}
          <Route path="/services" element={<ServicesIndex />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/expertise" element={<ExpertisePage />} />
          <Route path="/facility-management" element={<FacilityManagementPage />} />
          <Route path="/quote" element={<QuotePage />} />
          <Route path="/quote/:slug" element={<QuotePage />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/privacy" element={<PrivacyNotice />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/accessibility" element={<AccessibilityStatement />} />
          <Route path="/offices" element={<RegisteredOffices />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/areas/:slug" element={<AreaLanding />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/leads" element={<AdminDashboard />} />
          <Route path="/admin/pages" element={<AdminPages />} />
          <Route path="/admin/pages/:pageId" element={<PageEditor />} />
          <Route path="/admin/services" element={<AdminServices />} />
          <Route path="/admin/media" element={<AdminMedia />} />
          <Route path="/admin/site-images" element={<AdminSiteImages />} />
          <Route path="/admin/integrations" element={<AdminIntegrations />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/blog" element={<AdminBlog />} />
          <Route path="/admin/blog/:postId" element={<BlogEditor />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/hiring" element={<AdminHiring />} />
          <Route path="/admin/collections/:collection" element={<AdminCollection />} />
          <Route path="/admin/activity" element={<AdminActivity />} />
          <Route path="/admin/pipeline" element={<AdminPipeline />} />

          {/* Dynamic CMS page — must be LAST */}
          <Route path="/:slug" element={<DynamicPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <PublicChrome />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
